export const fontFamily = {
    /**
     * ```css
     * font-family: ui-monospace, "SF Mono", Menlo, Consolas, "Liberation Mono", "Oxygen Mono", "Ubuntu Mono", monospace;
     * ```
     */
    "code": "var(--fontFamilyCode)",
    /**
     * ```css
     * font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Oxygen Sans", Ubuntu, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
     * ```
     */
    "default": "var(--fontFamilyDefault)"
} as const;

export const text = {
    "body": {
        "bold": {
            /**
             * ```css
             * font-weight: 600;
             * font-size: 1rem;
             * line-height: 1.5rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "large": "var(--textBodyBoldLarge)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.875rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "medium": "var(--textBodyBoldMedium)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.8125rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "small": "var(--textBodyBoldSmall)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.75rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "xSmall": "var(--textBodyBoldXSmall)"
        },
        "regular": {
            /**
             * ```css
             * font-weight: 400;
             * font-size: 1rem;
             * line-height: 1.5rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "large": "var(--textBodyRegularLarge)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.875rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "medium": "var(--textBodyRegularMedium)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.8125rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "small": "var(--textBodyRegularSmall)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.75rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyDefault);
             * ```
             */
            "xSmall": "var(--textBodyRegularXSmall)"
        }
    },
    "code": {
        "bold": {
            /**
             * ```css
             * font-weight: 600;
             * font-size: 1rem;
             * line-height: 1.5rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "large": "var(--textCodeBoldLarge)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.875rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "medium": "var(--textCodeBoldMedium)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.8125rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "small": "var(--textCodeBoldSmall)",
            /**
             * ```css
             * font-weight: 600;
             * font-size: 0.75rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "xSmall": "var(--textCodeBoldXSmall)"
        },
        "regular": {
            /**
             * ```css
             * font-weight: 400;
             * font-size: 1rem;
             * line-height: 1.5rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "large": "var(--textCodeRegularLarge)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.875rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "medium": "var(--textCodeRegularMedium)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.8125rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "small": "var(--textCodeRegularSmall)",
            /**
             * ```css
             * font-weight: 400;
             * font-size: 0.75rem;
             * line-height: 1.25rem;
             * font-family: var(--fontFamilyCode);
             * ```
             */
            "xSmall": "var(--textCodeRegularXSmall)"
        }
    },
    "heading": {
        /**
         * ```css
         * font-weight: 600;
         * font-size: 3rem;
         * line-height: 3.5rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "2xLarge": "var(--textHeading2xLarge)",
        /**
         * ```css
         * font-weight: 600;
         * font-size: 1.5rem;
         * line-height: 2rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "large": "var(--textHeadingLarge)",
        /**
         * ```css
         * font-weight: 600;
         * font-size: 1.25rem;
         * line-height: 1.75rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "medium": "var(--textHeadingMedium)",
        /**
         * ```css
         * font-weight: 600;
         * font-size: 1rem;
         * line-height: 1.5rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "small": "var(--textHeadingSmall)",
        /**
         * ```css
         * font-weight: 600;
         * font-size: 2rem;
         * line-height: 2.75rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "xLarge": "var(--textHeadingXLarge)",
        /**
         * ```css
         * font-weight: 600;
         * font-size: 0.75rem;
         * line-height: 1.25rem;
         * font-family: var(--fontFamilyDefault);
         * ```
         */
        "xSmall": "var(--textHeadingXSmall)"
    }
} as const;